import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import Name from './components/PropertyInformationPopoverName';
import Description from './components/PropertyInformationPopoverDescription';
import HorizontalRuleWithSpace from './components/PropertyInformationPopoverHorizontalRuleWithSpace';
import ValueRow from './components/PropertyInformationPopoverValueRow';
import EditLink from './components/PropertyInformationPopoverEditLink';
import UsedIn from './components/PropertyInformationPopoverUsedIn';
import FieldType from './components/PropertyInformationPopoverFieldType';
import PropertyType from './components/PropertyInformationPopoverPropertyType';
import SubHeader from './components/PropertyInformationPopoverSubHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PropertyInformationPopoverContentUI = ({
  loading,
  label,
  description,
  propertyType,
  fieldType,
  usageCount,
  editLink,
  usagesLink
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "start",
    marginBlockEnd: "400",
    onClick: event => {
      // prevent clicks inside the popover from triggering property selection
      event.stopPropagation();
    },
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "100",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(Name, {
        label: label,
        loading: loading
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "100",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(Description, {
        description: description,
        loading: loading
      })
    }), /*#__PURE__*/_jsx(HorizontalRuleWithSpace, {}), /*#__PURE__*/_jsx(Text, {
      as: "h7",
      typography: "heading-50",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.propertyInformationPopover.details.title"
      })
    }), /*#__PURE__*/_jsx(SubHeader, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.propertyInformationPopover.details.propertyType.title"
      })
    }), /*#__PURE__*/_jsx(PropertyType, {
      propertyType: propertyType,
      loading: loading
    }), /*#__PURE__*/_jsx(SubHeader, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.propertyInformationPopover.details.fieldType.title"
      })
    }), /*#__PURE__*/_jsx(FieldType, {
      fieldType: fieldType,
      loading: loading
    }), /*#__PURE__*/_jsx(SubHeader, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.propertyInformationPopover.details.usedIn.title"
      })
    }), /*#__PURE__*/_jsx(ValueRow, {
      children: /*#__PURE__*/_jsx(UsedIn, {
        usageCount: usageCount,
        usagesLink: usagesLink,
        loading: loading
      })
    }), /*#__PURE__*/_jsx(EditLink, {
      editLink: editLink
    })]
  });
};